import type {
  BasketWithOptions,
  WishlistWithOptions,
} from '@scayle/storefront-nuxt'
import { sustainabilityAttributes } from '../utils/sustainability'

export const DEFAULT_PRICE_PROMOTION_KEY = 'MM'

export const WISHLIST_WITH = {
  items: {
    variant: {
      attributes: {
        withKey: [
          'sizeCategory',
          'sizeCategorySize',
          'price',
          'size',
          'erpSizeKey',
          'restockDate',
        ],
      },
    },
    product: {
      attributes: {
        withKey: ['color', 'brand', 'name', 'mainOrderNumberList', 'sizeNote'],
      },
      advancedAttributes: {
        withKey: ['mainOrderNumber'],
      },
      categories: 'all',
      variants: {
        attributes: {
          withKey: [
            'sizeCategory',
            'sizeCategorySize',
            'price',
            'size',
            'erpSizeKey',
          ],
        },
        lowestPriorPrice: true,
      },
      images: {
        attributes: {
          withKey: ['imageType', 'imageView', 'imageBackground', 'imageKind'],
        },
      },
      priceRange: true,
      lowestPriorPrice: true,
    },
  },
  pricePromotionKey: DEFAULT_PRICE_PROMOTION_KEY,
} as WishlistWithOptions

export const BASKET_WITH = WISHLIST_WITH as BasketWithOptions

export const DEFAULT_PRODUCT_WITH = {
  attributes: {
    withKey: [
      'colorRange',
      'colorHex',
      'color',
      'brand',
      'name',
      ...sustainabilityAttributes,
      'premiumsegment',
      'einfuehrungsgrund',
    ],
  },
  variants: {
    attributes: {
      withKey: ['price', 'sizeCategory'],
    },
  },
  siblings: {
    attributes: {
      withKey: ['colorRange', 'colorHex', 'color', 'brand', 'name'],
    },
  },
  images: {
    attributes: {
      withKey: [
        'assetType',
        'imageType',
        'imageView',
        'imageBackground',
        'imageKind',
      ],
    },
  },
  priceRange: true,
  categories: {
    properties: {
      withName: ['baseCategories'],
    },
  },
}

export const PRODUCT_LISTING_WITH = {
  ...DEFAULT_PRODUCT_WITH,
  siblings: {
    attributes: {
      withKey: ['colorRange', 'colorHex', 'color'],
    },
    images: {},
  },
}
